let scrollEventListener = null;
let observerPageTop = null;
let observerPageBottom = null;
let observerSideTop = null;
let observerSideBottom = null;

document.addEventListener('DOMContentLoaded', () => {
    const sidebarElement = document.querySelector('.product-wrapper.new-product-wrapper');

    checkScreenDimensions(sidebarElement)
    window.addEventListener('resize', () => checkScreenDimensions(sidebarElement));
});

const handleLongScreen = (operation) => {
    const sidebar = document.querySelector('.right-content');
    const addSticky = () => !sidebar.classList.contains('sticky') && sidebar.classList.add('sticky');
    const removeSticky = () => sidebar.classList.contains('sticky') && sidebar.classList.remove('sticky');

    operation === 'add' ? addSticky() : removeSticky();
}

const checkScreenDimensions = (sidebar) => {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const sidebarHeight = sidebar.clientHeight

    handleLongScreen('remove')
    if (viewportWidth < 481) {
        sidebar.style.cssText = '';

        // Toroljuk a regisztralt scroll event listenert
        if (scrollEventListener) {
            window.removeEventListener('scroll', scrollEventListener);
            scrollEventListener = null;
        }

        // Kikapcsoljuk az Intersection observereket ha vannak
        if (observerPageTop) {
            observerPageTop.disconnect();
            observerPageTop = null;
        }
        if (observerPageBottom) {
            observerPageBottom.disconnect();
            observerPageBottom = null;
        }
        if (observerSideTop) {
            observerSideTop.disconnect();
            observerSideTop = null;
        }
        if (observerSideBottom) {
            observerSideBottom.disconnect();
            observerSideBottom = null;
        }

        return;
    } else if (viewportHeight > sidebarHeight) {
        sidebar.style.cssText = '';

        // Toroljuk a regisztralt scroll event listenert
        if (scrollEventListener) {
            window.removeEventListener('scroll', scrollEventListener);
            scrollEventListener = null;
        }

        // Kikapcsoljuk az Intersection observereket ha vannak
        if (observerPageTop) {
            observerPageTop.disconnect();
            observerPageTop = null;
        }
        if (observerPageBottom) {
            observerPageBottom.disconnect();
            observerPageBottom = null;
        }
        if (observerSideTop) {
            observerSideTop.disconnect();
            observerSideTop = null;
        }
        if (observerSideBottom) {
            observerSideBottom.disconnect();
            observerSideBottom = null;
        }

        handleLongScreen('add')
    } else {
        handleScroll()
    }
}

const handleScroll = () => {
    let lastScrollPosition = 0; // A legutóbbi scroll pozíció tárolása
    let lastPageScrollPosition = 0; // A legutóbbi scroll pozíció tárolása

    // Elemek amiket figyelünk
    const pageTopTarget = document.querySelector('#page-top-intersector');
    const pageBottomTarget = document.querySelector('#page-bottom-intersector');
    const rightSideTopTarget = document.querySelector('#top-intersector');
    const rightSideBottomTarget = document.querySelector('#bottom-intersector');
    const productSideContents = document.querySelector('.product-side-contents');

    if (scrollEventListener === null) {
        scrollEventListener = function () {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            const productWrapper = document.querySelector('.product-wrapper.new-product-wrapper');

            if (currentScrollPosition < lastPageScrollPosition) {
                // Felfelé scrollozás esetén
                const scrollDirection = productWrapper.getAttribute('data-scroll-direction');

                if (scrollDirection === 'down') {
                    const productWrapperHeight = productWrapper.offsetHeight;
                    const scrolledPast = currentScrollPosition; // Mennyit görgettünk le
                    const viewportHeight = window.innerHeight;

                    const translateY = scrolledPast - (productWrapperHeight - (viewportHeight / 1.45));

                    productWrapper.style.cssText = `
                    position: relative;
                    transform: translate3d(0px, ${translateY}px, 0px);
                `;
                    productWrapper.setAttribute('data-scroll-direction', 'up');
                }
            } else {
                const scrollDirection = productWrapper.getAttribute('data-scroll-direction');

                if (scrollDirection === 'up') {
                    const scrolledPast = currentScrollPosition;
                    const viewportHeight = window.innerHeight;

                    const translateY = scrolledPast - (viewportHeight / 4);

                    productWrapper.style.cssText = `
                    position: relative;
                    transform: translate3d(0px, ${translateY}px, 0px);
                `;

                    productWrapper.setAttribute('data-scroll-direction', 'down');
                }
            }

            lastPageScrollPosition = currentScrollPosition; // Frissítjük a legutóbbi scroll pozíciót
        };

        window.addEventListener('scroll', scrollEventListener);
    }

    // Opciók az Intersection Observer számára
    const options = {
        root: null, // A viewportot használja mint viewport
        threshold: 0.1 // 10% kell, hogy látható legyen az elem előtt
    };

    const optionsSide = {
        root: null,
        threshold: 0.1
    };

    if (observerPageTop === null) {
        observerPageTop = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                // Ellenőrizzük, hogy felfelé scrolloztunk-e
                const productWrapper = document.querySelector('.product-wrapper.new-product-wrapper');
                const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                if (entry.isIntersecting && lastScrollPosition > currentScrollPosition) {
                    document.querySelector('.product-wrapper.new-product-wrapper').style.cssText = '';
                }
                lastScrollPosition = currentScrollPosition; // Frissítjük a legutóbbi scroll pozíciót

                productWrapper.setAttribute('data-scroll-direction', 'fixed-top');
            });
        }, options);
    }

    if (observerPageBottom === null) {
        observerPageBottom = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                if (entry.isIntersecting && currentScrollPosition > lastScrollPosition) {
                    // Csak lefelé scrollozáskor változtatunk
                    const productWrapper = document.querySelector('.product-wrapper.new-product-wrapper');
                    if (productWrapper && productSideContents) {
                        const sideContentsBottom = productSideContents.offsetHeight;
                        const translateY = sideContentsBottom - productWrapper.offsetHeight;
                        productWrapper.style.cssText = `
                        position: relative;
                        transform: translate3d(0px, ${translateY}px, 0px);
                    `;

                        productWrapper.setAttribute('data-scroll-direction', 'fixed-bottom');
                    }
                }
                lastScrollPosition = currentScrollPosition;
            });
        }, options);
    }

    if (observerSideTop === null) {
        observerSideTop = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                const productWrapper = document.querySelector('.product-wrapper.new-product-wrapper');
                const scrollDirection = productWrapper.getAttribute('data-scroll-direction');
                const wrapperRect = productWrapper.getBoundingClientRect(); // A productWrapper dimenzióinak lekérdezése
                const wrapperWidth = wrapperRect.width; // A productWrapper szélességének lekérdezése

                if (entry.isIntersecting && lastScrollPosition > currentScrollPosition && scrollDirection !== 'fixed-top') {
                    const productWrapper = document.querySelector('.product-wrapper.new-product-wrapper');
                    document.querySelector('.product-wrapper.new-product-wrapper').style.cssText = `
                    position: fixed;
                    top: 1px;
                    width: ${wrapperWidth}px;
                `;

                    // Hozzáadunk egy data attribútumot, amely jelzi a scrollozás irányát
                    productWrapper.setAttribute('data-scroll-direction', 'up');
                }
                lastScrollPosition = currentScrollPosition;
            });
        }, optionsSide);
    }

    if (observerSideBottom === null) {
        observerSideBottom = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                const productWrapper = document.querySelector('.product-wrapper.new-product-wrapper');
                const scrollDirection = productWrapper.getAttribute('data-scroll-direction');
                const wrapperRect = productWrapper.getBoundingClientRect(); // A productWrapper dimenzióinak lekérdezése
                const wrapperWidth = wrapperRect.width; // A productWrapper szélességének lekérdezése

                if (entry.isIntersecting && currentScrollPosition > lastScrollPosition && scrollDirection !== 'fixed-bottom') {
                    productWrapper.style.cssText = `
                    position: fixed;
                    bottom: 16px;
                    width: ${wrapperWidth}px;
                `;

                    // Hozzáadunk egy data attribútumot, amely jelzi a scrollozás irányát
                    productWrapper.setAttribute('data-scroll-direction', 'down');
                }
                lastScrollPosition = currentScrollPosition;
            });
        }, optionsSide);
    }

    observerPageTop.observe(pageTopTarget);
    observerPageBottom.observe(pageBottomTarget);
    observerSideTop.observe(rightSideTopTarget);
    observerSideBottom.observe(rightSideBottomTarget);
}